import React from 'react';

function HomeLocation(props: object) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.99984 22.1667H10.4998V15.1667H17.4998V22.1667H20.9998V11.6667L13.9998 6.41667L6.99984 11.6667V22.1667ZM4.6665 24.5V10.5L13.9998 3.5L23.3332 10.5V24.5H15.1665V17.5H12.8332V24.5H4.6665Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default HomeLocation;
